import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumUkNewDutyAbvRange implements BaseEnumType {
  private static allValues: EnumUkNewDutyAbvRange[] = []; // make sure this is top-most
  
  public static none = new EnumUkNewDutyAbvRange(0, "None", "enum_uk_new_duty_abv_range_none");
  public static to3_4 = new EnumUkNewDutyAbvRange(1, "To3_4", "enum_uk_new_duty_abv_range_to3_4");
  public static from3_5To8_4 = new EnumUkNewDutyAbvRange(2, "From3_5To8_4", "enum_uk_new_duty_abv_range_from3_5_to8_4");
  public static from8_5To22 = new EnumUkNewDutyAbvRange(3, "From8_5To22", "enum_uk_new_duty_abv_range_from8_5_to22");
  public static from23 = new EnumUkNewDutyAbvRange(4, "From23", "enum_uk_new_duty_abv_range_from23");
  public static from3_5To5_5 = new EnumUkNewDutyAbvRange(5, "From3_5To5_5", "enum_uk_new_duty_abv_range_from3_5_to5_5");
  public static from5_6To8_4 = new EnumUkNewDutyAbvRange(6, "From5_6To8_4", "enum_uk_new_duty_abv_range_from5_6_to8_4");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumUkNewDutyAbvRange.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumUkNewDutyAbvRange.none; }
  public isTo3_4() { return this === EnumUkNewDutyAbvRange.to3_4; }
  public isFrom3_5To8_4() { return this === EnumUkNewDutyAbvRange.from3_5To8_4; }
  public isFrom8_5To22() { return this === EnumUkNewDutyAbvRange.from8_5To22; }
  public isFrom23() { return this === EnumUkNewDutyAbvRange.from23; }
  public isFrom3_5To5_5() { return this === EnumUkNewDutyAbvRange.from3_5To5_5; }
  public isFrom5_6To8_4() { return this === EnumUkNewDutyAbvRange.from5_6To8_4; }

  public static getValues(): readonly EnumUkNewDutyAbvRange[] {
    return EnumUkNewDutyAbvRange.allValues;
  }

  public static getValuesExcept0(): readonly EnumUkNewDutyAbvRange[] {
    return EnumUkNewDutyAbvRange.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumUkNewDutyAbvRange {
    const found = EnumUkNewDutyAbvRange.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumUkNewDutyAbvRange - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumUkNewDutyAbvRange): EnumUkNewDutyAbvRange {
    const found = name ? EnumUkNewDutyAbvRange.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumUkNewDutyAbvRange - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumUkNewDutyAbvRange>): boolean {
    return this.key === other?.key;
  }
}